// Lightweight client-side memory: who "you" are (for insights) and trips you've made.
export interface SavedTripRef {
  slug: string;
  title: string;
  destination: string;
  createdAt: string;
}

const OWNER_KEY = "travelhub.owner";
const TRIPS_KEY = "travelhub.trips";

export function getOwnerEmail(): string {
  return localStorage.getItem(OWNER_KEY) || "";
}
export function setOwnerEmail(email: string): void {
  if (email) localStorage.setItem(OWNER_KEY, email.trim().toLowerCase());
}

export function getMyTrips(): SavedTripRef[] {
  try {
    return JSON.parse(localStorage.getItem(TRIPS_KEY) || "[]");
  } catch {
    return [];
  }
}

export function rememberTrip(ref: SavedTripRef): void {
  const trips = getMyTrips().filter((t) => t.slug !== ref.slug);
  trips.unshift(ref);
  localStorage.setItem(TRIPS_KEY, JSON.stringify(trips.slice(0, 50)));
}
